export default __webpack_public_path__ + "static/media/01.54b33f45.png";